const Document = (props) => {
  const src = props.src || null;
  const signerLocations = props.signerLocations;
  const completedSignatures = props.completedSignatures;

  return (
    <div
      className="docContainer"
      style={{
        boxShadow: "3px 3px 10px rgba(1, 1, 1, 0.5)",
      }}
    >
      <img src={src} className="docimg" alt=""></img>
      {completedSignatures}
      {signerLocations}
    </div>
  );
};
export default Document;
